import { createApp } from 'vue';
import App from './App.vue';
import VueLazyload from 'vue-lazyload';
import VueGtag from 'vue-gtag'
import './assets/styles.css';
import './assets/tailwind.css';

const app = createApp(App);

app.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 3,
    listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'],
    observer: true,
    observerOptions: {
        rootMargin: '0px',
        threshold: 0.1
    },
    loading: './images/loading.gif',
    error: './images/x-icon.png'
});

app.use(VueGtag, {
    config: {
        id: 'G-P5JC5FQ2PW'
    }
});

app.config.globalProperties.$mciconsUrl = 'https://app.ccleaf.com/?ref=mcicons';

app.mount('#app');
